<article class="flex ps-medium" [ngClass]="styleClasses$() | async" [class.g-small]="isNewBrand()">
  @for (icon of icons$() | finObsToArray; track $index) {
    <div class="icon-container flex" [class.flex--center]="!isNewBrand()" [class.ms-small-r]="!isNewBrand()">
      <fcom-icon [name]="icon | async" [class.icon-large]="!isNewBrand()" />
    </div>
  }
  <div class="text-container flex flex--center">
    <div [innerHTML]="content$() | async | finSafe: 'html'"></div>
  </div>
</article>
